import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import Payment from './components/Payment';
import PaymentCompleted from './components/PaymentCompleted';
import PaymentFailed from './components/PaymentFailed';
import PaymentPage from './components/PaymentPage';
import Error404 from './components/error-404';
import { Helmet } from 'react-helmet'

const App: React.FC = () => (
  <>
  <head>
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  </head>
  <div className="App flex flex-grow items-center flex-col w-full h-screen">
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:id" element={<Payment />} />
        <Route path="/page/:id" element={<PaymentPage />} />
        <Route path="/payment-completed" element={<PaymentCompleted />} />
        <Route path="/payment-failed" element={<PaymentFailed />} />
        <Route path="/error/404" element={<Error404 />} />
      </Routes>
    </Router>
  </div>
  </>
);

export default App;
